import apiClient from './axiosClient';

export const authApi = {
    login: async (username, password, turnstileToken) =>
    //apiClient.post('/auth/login', { username, password }),
        await apiClient.post('/api/provider/auth/providersiginmethod', { username, password, turnstileToken }),

    refreshToken: async (refreshToken, isImpersonate) =>
      await apiClient.post('/api/provider/auth/getRefreshAccessToken', { refreshToken, isImpersonate }),

  logout: () =>
      apiClient.get('/api/provider/auth/logout'),

    register: (data) =>
        apiClient.post('/auth/register', data),

    forgotPassword: async (userEmail, turnstileToken) => 
        await apiClient.post('/api/provider/auth/forgot-password', { userEmail: userEmail, turnstileToken:turnstileToken }),

    forgotUsername:async (email, turnstileToken = null) =>
        await apiClient.post('/api/provider/auth/sendForgottedUsername', { userEmail: email, turnstileToken: turnstileToken }),

    resetPassword: (token, newPassword) =>
        apiClient.post('/auth/reset-password', { token, newPassword }),

   sendMfaCode: async (otpSecretKey, otpChannel) =>
      await apiClient.post('/api/provider/auth/providertwofactorsigninmethod', { twoFaSessionId: otpSecretKey, otpChannel:otpChannel }),

    verifyMfa: async(otpsecretkey, otp) =>
       await apiClient.post('/api/provider/auth/providerverify-otp', { otpsecretkey, otp }),

    resendMfa: async (twoFaSessionId, otpChannel) =>
       await apiClient.post('/api/provider/auth/providertwofactorsigninmethod', { twoFaSessionId, otpChannel }),

    impersonate: (userId) =>
        apiClient.post('/api/provider/auth/impersonate', { userId }),
        //apiClient.post('/auth/impersonate', { userId }),

    endImpersonation: async() =>
        //apiClient.post('/auth/end-impersonation'),
        await apiClient.get('/api/provider/auth/logout'),

    recordEvent: async (params) => {
      
        var res = await apiClient.post(`/api/provider/auth/recordEvent`, {
            userName: params.userName,
            eventType: params.eventType,
            eventData:JSON.stringify(params.eventData)
        });
    },
    recordImpersonation: async (params) => {

        console.log("REACHED AT recordImpersonation : "+JSON.stringify(params));

        var res = await apiClient.post(`/api/provider/auth/recordImpersonatedUserEvent`, {
            
            eventType: params.eventType,
            userId: params.userId,
            impersonatedUserId: params.impersonatedUserId,
            eventData: JSON.stringify(params.eventData)
        });
    }

        
};
